import {red} from '@material-ui/core/colors';
import {createMuiTheme} from '@material-ui/core/styles';

// A custom theme for this app
const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#173147',
            light: 'rgba(60,112,156,0.7)',
            contrastText: '#fff'
        },
        secondary: {
            main: '#2b7a3f',
            contrastText: '#fff'
        },
        error: {
            main: red.A400,
            contrastText: '#fff'
        },
        background: {
            default: '#fff',
        },
        text: {
            primary: '#333',
            secondary: '#666',
            disabled: '#777',
            hint: '#777'
        }
    },
});
theme.zIndex = {
    top: 1,
    bar: 9,
    modal: 10
};
theme.overrides = {
    MuiAppBar: {
        root: {
            zIndex: theme.zIndex.bar
        }
    },
    MuiContainer: {
        root: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
        }
    },
    MuiPaper: {
        rounded: {
            borderRadius: 8
        }
    },
    MuiAvatar: {
        colorDefault: {
            backgroundColor: '#ececec'
        },
        rounded: {
            borderRadius: 8
        }
    },
    MuiButton: {
        root: {
            padding: theme.spacing(1, 2)
        }
    },
    MuiOutlinedInput: {
        input: {
            padding: theme.spacing(2, 2)
        }
    },
    MuiFormHelperText: {
        contained: {
            marginLeft: 0,
        }
    },
    MuiFormControlLabel: {
        root: {
            marginRight: 0
        }
    }
}
export default theme;
